import { IntentSourceEnum } from 'src/app/shared/enums';

export const DEFAULT_INTENT_SOURCE_PARAM_KEY = 'defaultIntentSource';
export const DEFAULT_INTENT_SOURCE_VALUE = IntentSourceEnum.SALES_INTEL;
